import { useAuth, useAuthUser, useLoginWithRedirect } from '@frontegg/react';
import React, { FC, useContext, useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import useSWR from 'swr';
import Dashboard from './components/Dashboard/dashboard';
import DefaultLayout from './components/DefaultLayout/defaultLayout';
import HotAlertDetails from './components/HotAlerts/DetailsPage/hotAlertDetails';
import HotAlertsSummary from './components/HotAlerts/hotAlertsSummary';
import Settings from './components/Settings/settings';
import Surveys from './components/Surveys/surveys';
import Tenants from './components/Tenants/tenants';
import { TenantContext } from './contexts/tenantContext';
import { ToastContainerStyled } from './styled';
import useFetcher from './utils/hooks/useFetcher';

interface TenantOption {
    id: number;
    code: string;
    label: string;
}

const AskiaTenantInitializer: FC = () => {
    const user = useAuthUser();
    const fetcher = useFetcher();
    const [, setSelectedSchema] = useContext(TenantContext)!;
    const isAskia = JSON.parse(user.metadata).database_schema === 'askia';

    const { data: tenants } = useSWR<TenantOption[]>(
        isAskia ? [`${process.env.REACT_APP_API_URL}/tenant/`] : null,
        fetcher,
    );

    useEffect(() => {
        if (isAskia && tenants && tenants.length > 0) {
            const saved = localStorage.getItem('lastSelectedTenant');
            const isValid = saved && tenants.some((t) => t.code === saved);
            setSelectedSchema(isValid ? saved : tenants[0].code);
        }
    }, [tenants]);

    return null;
};

const App: FC = () => {
    const { isAuthenticated, user } = useAuth();
    const loginWithRedirect = useLoginWithRedirect();

    if (!isAuthenticated) {
        loginWithRedirect();
    } else {
        localStorage.setItem('token', user.accessToken);
    }

    const [selelectedSchema, setSelectedSchema] = useState<string | null>(JSON.parse(user.metadata).database_schema);

    return (
        <TenantContext.Provider value={[selelectedSchema, setSelectedSchema]}>
            <AskiaTenantInitializer />
            <DefaultLayout>
                <main>
                    <Routes>
                        <Route element={<Surveys />} path="/" />
                        <Route element={<Tenants />} path="/tenants" />
                        <Route element={<Settings />} path="/settings" />
                        <Route element={<Dashboard />} path="/survey/:surveyId/dashboard/:dashboardId" />
                        <Route element={<HotAlertsSummary />} path="/survey/:surveyId/hot-alerts" />
                        <Route element={<HotAlertDetails />} path="/survey/:surveyId/hot-alerts/:hotAlertId" />
                    </Routes>
                </main>
                <ToastContainerStyled autoClose={4000} />
            </DefaultLayout>
        </TenantContext.Provider>
    );
};

export default App;
